import React from 'react';
import Select from 'react-select';
import { ReactSVG } from 'react-svg';
import selectStyles from './CurrencySelectStyles';
import arrow from 'src/assets/images/icons/currency_arrow.svg';
import styles from './CurrencySelect.module.scss';
import { components, OptionProps, SingleValueProps } from 'react-select';

const DropdownIndicator = (): JSX.Element => <ReactSVG src={arrow} className={styles.arrow} />;

interface OptionType {
  value: string;
  label: string;
}

const Option = (props: OptionProps<OptionType, false>): JSX.Element => {
  return (
    <components.Option {...props}>
      <span
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block'
        }}
      >
        {props.children}
      </span>
    </components.Option>
  );
};

const SingleValue = (props: SingleValueProps<OptionType>): JSX.Element => {
  return (
    <components.SingleValue {...props}>
      <span
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block'
        }}
      >
        {props.children}
      </span>
    </components.SingleValue>
  );
};

interface CurrencySelectProps {
  name: string;
  value: { value: string; label: string };
  onBlur?: () => void;
  onChange: (value: { value: string; label: string }) => void;
  options: Array<{ value: string; label: string }>;
  minMenuHeight?: number;
  maxMenuHeight?: number;
  isDisabled?: boolean;
  isSearchable?: boolean;
  width?: number | string;
}

const DEFAULT_MENU_HEIGHT = 145;

const CurrencySelect = ({
  name = null,
  value,
  options = [],
  onBlur,
  onChange,
  minMenuHeight = DEFAULT_MENU_HEIGHT,
  maxMenuHeight = DEFAULT_MENU_HEIGHT,
  isDisabled = false,
  isSearchable = false,
  width
}: CurrencySelectProps): JSX.Element => (
  <Select
    isSearchable={isSearchable}
    name={name}
    options={options}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    isDisabled={isDisabled}
    minMenuHeight={minMenuHeight}
    maxMenuHeight={maxMenuHeight}
    placeholder="Select"
    components={{ DropdownIndicator, Option, SingleValue }}
    styles={selectStyles(width)}
  />
);
export default CurrencySelect;
